<template>
  <div class="detail">
    <div class="left-detail">
      <video autoplay alt="" class="img-item" >
        <source src="./../assets/images/video.mp4"  type="video/mp4">
      </video>
    </div>
    <div class="right-detail">
      <div style="padding-left: 10vw;">
        <div style="font-size: 14px;margin-bottom: 10px;">M63142</div>
        <div style="font-size: 20px;margin-bottom: 10px;">衣服1</div>
        <div style="font-size: 14px;margin-bottom: 10px;">¥120.00</div>
        <div style="font-size: 24px;font-weight: bold;">诚邀私享顾问服务 400 6588 555</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Detail'
}
</script>

<style lang="less" scoped>
.detail {
  height: 1600px;
  display: flex;
  .left-detail {
    width: 50vw;
    background: #b49a9a;
    position: relative;
    overflow: hidden;
  }
  .right-detail {
    display: flex;
    align-items: center;
  }
}

.img-item {
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>